export default __webpack_public_path__ + "static/media/ReactIcon.69bdee9b.png";